import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { FREQUENCIES } from "../forms-allocation/constants";
import { Dropdown } from "primereact/dropdown";
import { controlMeasureAdd, controlMeasureTypeAdd, controlMeasureTypeUpdate, controlMeasureUpdate } from "../../service/controlMeasureService";
import { QuillEditor } from "../../components/QuillEditor";
import ImageS3Upload from "../../components/ImageS3Upload";
import { placeholder } from "../../assets/placeholder";
import DropdownApi from "../../components/DropdownApi";
export default function ControlMeasureAdd(modalProps: any) {
  const details = modalProps?.details;

  const id = modalProps?.uuid;

  const [name, setName] = useState(details?.name || "");
  const [description, setDescription] = useState(details?.description || "");
  const [photo, setPhoto] = React.useState(placeholder);
  const [file, setFile] = React.useState<File>();
  const [type, setType] = useState(details?.type);



  async function addIndustry() {
    const updateDetails = {
      name,
      description,
      s3_key: !!file ? `equipment/${id}` : undefined,
      type,
    };
    if (modalProps.id) {
      controlMeasureUpdate(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Control Measure Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      controlMeasureAdd(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Control Measure Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl>
            <ImageS3Upload
              photo={photo}
              setPhoto={setPhoto}
              s3Key={`control-measure/${id}`}
              file={file}
              setFile={setFile}
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Name<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <DropdownApi
                apiPath="control-measure-type"
                optionLabel="name"
                optionValue="id"
                label="Control Measure Type"
                selectedData={type}
                setSelectedData={setType}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <QuillEditor
            label="Description"
            hidePlaceholder={true}
            content={description}
            setContent={setDescription}
            toast={modalProps.toast}
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
